import { render, staticRenderFns } from "./ClienteEditTabInformation.vue?vue&type=template&id=31d4d3c8&"
import script from "./ClienteEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./ClienteEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./ClienteEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports